__turbopack_context__.v({
  "bottom_button_padding": "Contents-module-scss-module__W2TFKW__bottom_button_padding",
  "content": "Contents-module-scss-module__W2TFKW__content",
});
